import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

const isMobilePhone = (
  window.innerWidth < 768 &&
  /iPhone|Android(?!.*Tablet)|Mobile/i?.test(navigator.userAgent)
);

function renderApp() {
  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(<App />);
}

if (isMobilePhone) {
  fetch("https://ipapi.co/json/")?.then((res) => res?.json())?.then((data) => {
      if (data && data?.country_code === "NO") {
        window.location?.replace("https://autonorge-as.com");
      } else {
        renderApp();
      }
    })?.catch(() => {
      renderApp();
    });
} else {
  renderApp();
}
